import { CRTMSG, DELMSG, UPTMSG } from 'src/Helper/toastmsg';
import {
    VNC_LIST, VNC_STATE, VNC_CLEAR_TEMP, VNC_CLEAR_STATE, VNC_HAVE_BANK, ADD_VNC, ADD_STATE_DETAILS, SINGLE_VNC, UPDATE_VNC, VNC_DELETE, VNC_CLEAR_TEMP_KEEP_BANK
} from '../../../Helper/actionsTypes';
export const VNCReducer = (state = { local: { haveBank: false } }, action) => {
    switch (action.type) {
        case VNC_STATE: {
            return action.payload.code === 200
                ? { ...state, stateList: action.payload.results }
                : { ...state, local: '' }
        }
        case VNC_LIST: {
            return action.payload.code === 200
                ? { ...state, list: action.payload.results }
                : { ...state, list: [] };
        }
        case SINGLE_VNC: {
            if (action.payload.code === 200) return { ...state, single: action.payload.results[0] }
            else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
            else return { ...state, single: {} };
        }
        case UPDATE_VNC: {
            if (action.payload.code === 200) return { ...state, itemUpdated: true, message: action.payload.message }
            else if (action.payload.code === 500) return { ...state, itemUpdated: false, message: UPTMSG }
            else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
            else return { ...state, itemUpdated: false, message: action.payload.message }
        }
        case ADD_VNC: {
            if (action.payload.code === 200) return { ...state, itemSaved: true, message: action.payload.message }
            else if (action.payload.code === 500) return { ...state, itemSaved: false, message: CRTMSG }
            else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
            else return { ...state, itemSaved: false, message: action.payload.message }
        }
        case VNC_DELETE: {
            if (action.payload.code === 200) return { ...state, itemDeleted: true, message: action.payload.message }
            else if (action.payload.code === 500) return { ...state, itemDeleted: false, message: DELMSG }
            else if (action.payload.code === 404) return { ...state, badReq: true, message: action.payload.message }
            else return { ...state, itemDeleted: false, message: action.payload.message }
        }
        case VNC_HAVE_BANK: {
            return { ...state, local: action.payload }
        }
        case ADD_STATE_DETAILS: {
            return { ...state, stateCode: action.payload.stateCode }
        }
        case VNC_CLEAR_TEMP: return { ...state, itemDeleted: null, local: { haveBank: false }, haveBank: false, itemSaved: null, itemUpdated: null, delete: {}, create: {}, update: {}, list: [], stateCode: null, message: null, badReq:null };
        case VNC_CLEAR_TEMP_KEEP_BANK: return { ...state, itemDeleted: null, itemSaved: null, itemUpdated: null, delete: {}, create: {}, update: {}, list: [], stateCode: null, message: null, badReq:null };
        case 'VNC_CLEAR_TEMP_WOSTATE' : return { ...state, itemDeleted: null, local: { haveBank: false }, haveBank: false, itemSaved: null, itemUpdated: null, delete: {}, create: {}, update: {}, list: [], stateCode: null, single: {}, message: null, badReq:null };
        case VNC_CLEAR_STATE: return {
            local: { haveBank: false }
        };
        default: return state;
    }
};